(function(){
var $=function(i){return document.getElementById(i)};
var mi=$('mainimg');
[].forEach.call(document.querySelectorAll('.th'),function(b){b.addEventListener('click',function(){if(mi)mi.src=b.getAttribute('data-src')})});
var ba=$('ba');
if(ba){ba.querySelector('input').addEventListener('input',function(e){ba.style.setProperty('--p',e.target.value+'%')})}
var buy=$('buy');
if(!buy)return;
var pills=[].slice.call(document.querySelectorAll('.pill'));
pills.forEach(function(p){p.addEventListener('click',function(){
var id=p.getAttribute('data-id');
pills.forEach(function(q){q.setAttribute('aria-pressed',q===p?'true':'false')});
var cn=$('cn');if(cn)cn.textContent=p.textContent;
[].forEach.call(document.querySelectorAll('select[data-u="1"]'),function(s){s.value=id});
})});
function items(){
var chk=document.querySelector('input[name=b]:checked');
var sels=chk.closest('.bun').querySelectorAll('select');
var m={};
[].forEach.call(sels,function(s){m[s.value]=(m[s.value]||0)+1});
return Object.keys(m).map(function(k){return {id:Number(k),quantity:m[k]}});
}
var err=$('err');
function add(btn){
btn.disabled=true;if(err)err.hidden=true;
fetch(buy.getAttribute('data-add-url'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items()})})
.then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d}})})
.then(function(x){if(!x.ok)throw new Error(x.d.description||'Could not add to cart');window.location.href=buy.getAttribute('data-cart-url')})
.catch(function(e){if(err){err.textContent=e.message;err.hidden=false}btn.disabled=false});
}
var a1=$('add'),a2=$('add2');
if(a1)a1.addEventListener('click',function(){add(a1)});
if(a2)a2.addEventListener('click',function(){add(a2)});
var bar=$('bar');
if(bar&&'IntersectionObserver' in window){
new IntersectionObserver(function(e){bar.classList.toggle('on',!e[0].isIntersecting&&e[0].boundingClientRect.top<0)}).observe(buy);
}
})();
